import { path } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var generateOTP = function generateOTP(axios, email) {
  return axios.post(urls.apiV3("/prepaid-cards/otp"), {
    email: email
  }).then(path(['data', 'data']));
};
var getById = function getById(axios, id) {
  return axios.get(urls.apiV3("/prepaid-cards/".concat(id))).then(path(['data', 'data']));
};
var getSensitiveCardDetails = function getSensitiveCardDetails(axios, id) {
  return axios.get(urls.apiV3("/prepaid-cards/".concat(id, "/details"))).then(path(['data', 'data']));
};
var reportMisuse = function reportMisuse(axios, id, status) {
  return axios.post(urls.apiV3("/prepaid-cards/".concat(id, "/report-misuse")), {
    status: status
  }).then(path(['data', 'data']));
};
export default {
  generateOTP: withAxios(generateOTP),
  getById: withAxios(getById),
  getSensitiveCardDetails: withAxios(getSensitiveCardDetails),
  reportMisuse: withAxios(reportMisuse)
};